import Kings from "assets/images/kings.png"
import Jessica from 'assets/images/jessica.png'
import Silvia from 'assets/images/SilviaSquare.png'
import Arthur from 'assets/images/Arthur.jpg'
import Ege from 'assets/images/Ege.jpg'
export const People = [
	{
		name: "Kingsley Okonkwo",
		role: "Managing Director",
		image: Kings
	},
	{
		name: "Jéssica Groba Represas",
		role: "Co-Founder and Treasurer",
		image: Jessica
	},
	{
		name: "Silvia Lawrence",
		role: "Co-founder and Secretary",
		image: Silvia
	},
	{
		name: "Arthur Ramos",
		role: "Front End Developer",
		image: Arthur
	},
	{
		name: "Ege Coskun",
		role: "Industrial & UX Designer",
		image: Ege
	},


];